// extracted by mini-css-extract-plugin
export default {"content_loading":"terms-of-service_content_loading__Ytn1R","conditions":"terms-of-service_conditions__9i8Vv","error_message":"terms-of-service_error_message__PnV8W"};